import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

export const selectAppContainerState = (state: any) =>
  state.get('appContainer');

const makeSelectListings = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('listings')) {
      return appContainer.get('listings').toJS();
    }
    return {};
  });

const makeSelectListingsIntervenants = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('intervenants')) {
      return appContainer.get('intervenants').toJS();
    }
    return {};
  });

const makeSelectLinkToBeneficiaryCodes = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('linkToBeneficiaryCodes')) {
      return appContainer.get('linkToBeneficiaryCodes').toJS();
    }
    return {};
  });

const makeSelectListingsByField = (field: string) =>
  createSelector(makeSelectListings(), (listings: any) => {
    if (!isEmpty(listings) && listings[field]) {
      return listings[field];
    }
    return [];
  });

const makeSelectLawyerNotifications = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('lawyerNotifications')) {
      return appContainer.get('lawyerNotifications').toJS();
    }
    return [];
  });

const makeSelectManagerNotifications = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('managerNotifications')) {
      return appContainer.get('managerNotifications').toJS();
    }
    return [];
  });

const makeSelectKeycloakToken = () =>
  createSelector(selectAppContainerState, appContainer => {
    if (appContainer && appContainer.get('keycloakToken')) {
      return appContainer.get('keycloakToken');
    }
    return null;
  });
const makeSelectCurrentInstanceTab = () =>
  createSelector(selectAppContainerState, appContainer => {
    if (appContainer && appContainer.get('currentTabInstance')) {
      return appContainer.get('currentTabInstance');
    }
    return null;
  });
const makeSelectExpertNotifications = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('expertNotifications')) {
      return appContainer.get('expertNotifications').toJS();
    }
    return [];
  });
const makeSelectOpeningManagerNotificationsMixedClaim = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (
      appContainer &&
      appContainer.get('openingManagerNotificationsMixedClaim')
    ) {
      return appContainer.get('openingManagerNotificationsMixedClaim').toJS();
    }
    return [];
  });
const makeSelectClaimNumber = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('claimNumber')) {
      const selectedClaim = appContainer.get('claimNumber');
      return selectedClaim;
    }
    return null;
  });
const makeSelectNotification = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('notification')) {
      const notification = appContainer.get('notification').toJS();
      return notification;
    }
    return {};
  });
const makeSelectOpenUnlockClaimDialog = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('openUnlockClaimDialog')) {
      const openUnloackClaim = appContainer.get('openUnlockClaimDialog');
      return openUnloackClaim;
    }
    return null;
  });
const makeSelectCurrentTabJudiciaryProcessManager = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabJudiciaryProcessManager')) {
      const currentTabJudiciaryProcessManager = appContainer.get(
        'currentTabJudiciaryProcessManager',
      );
      return currentTabJudiciaryProcessManager;
    }
    return 0;
  });
const makeSelectCurrentTabManager = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabManager')) {
      const currentTabManager = appContainer.get('currentTabManager');
      return currentTabManager;
    }
    return null;
  });
const makeSelectGlobalCurrentTabManager = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentGlobalTabIndexManager')) {
      const currentGlobalTabIndexManager = appContainer.get(
        'currentGlobalTabIndexManager',
      );
      return currentGlobalTabIndexManager;
    }
    return null;
  });
const makeSelectNotifFeeNoteManager = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('feeNote')) {
      const feeNote = appContainer.get('feeNote').toJS();
      return feeNote;
    }
    return null;
  });
const makeSelectNotificationsInboxes = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('notificationsInboxes')) {
      const notificationsInboxes = appContainer
        .get('notificationsInboxes')
        .toJS();
      return notificationsInboxes;
    }
    return [];
  });
const makeSelectCountNotificationManagers = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('countNotificationsManagers')) {
      const countNotificationManager = appContainer.get(
        'countNotificationsManagers',
      );

      return countNotificationManager;
    }
    return null;
  });
const makeSelectCountInboxesManagers = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('countInboxesManagers')) {
      const countNotificationManager = appContainer.get('countInboxesManagers');

      return countNotificationManager;
    }
    return null;
  });
const makeSelectCurrentTabIndexExpertise = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabIndexExpertise')) {
      const currentTabIndexExpertise = appContainer.get(
        'currentTabIndexExpertise',
      );

      return currentTabIndexExpertise;
    }
    return null;
  });
const makeSelectCurrentTabIndexTransaction = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabIndexTransaction')) {
      const currentTabIndexTransaction = appContainer.get(
        'currentTabIndexTransaction',
      );

      return currentTabIndexTransaction;
    }
    return null;
  });

const makeSelectTransactionId = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('transactionId')) {
      const transactionId = appContainer.get('transactionId');

      return transactionId;
    }
    return null;
  });
const makeSelectCurrentRegulationPath = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentRegulationPath')) {
      const currentRegulationPath = appContainer
        .get('currentRegulationPath')
        .toJS();

      return currentRegulationPath;
    }
    return null;
  });
const makeSelectInboxesLawyerNotifications = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('inboxesLawyerNotifications')) {
      const inboxesLawyerNotifications = appContainer
        .get('inboxesLawyerNotifications')
        .toJS();
      return inboxesLawyerNotifications;
    }
    return [];
  });
const makeSelectCountInboxesLawyerNotifications = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('countInboxesLawyerNotifications')) {
      const countInboxesLawyerNotifications = appContainer.get(
        'countInboxesLawyerNotifications',
      );
      return countInboxesLawyerNotifications;
    }
    return null;
  });
const makeSelectGlobalCurrentTabLawyer = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentGlobalTabIndexLawyer')) {
      const currentGlobalTabIndexLawyer = appContainer.get(
        'currentGlobalTabIndexLawyer',
      );
      return currentGlobalTabIndexLawyer;
    }
    return null;
  });
const makeSelectCurrentTabJudiciaryProcessLawyer = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabJudiciaryProcessLawyer')) {
      const currentTabJudiciaryProcessLawyer = appContainer.get(
        'currentTabJudiciaryProcessLawyer',
      );
      return currentTabJudiciaryProcessLawyer;
    }
    return 0;
  });
const makeSelectCurrentTabLawyer = () =>
  createSelector(selectAppContainerState, (appContainer: any) => {
    if (appContainer && appContainer.get('currentTabLawyer')) {
      const currentTabLawyer = appContainer.get('currentTabLawyer');
      return currentTabLawyer;
    }
    return null;
  });

export {
  makeSelectListings,
  makeSelectListingsIntervenants,
  makeSelectLawyerNotifications,
  makeSelectManagerNotifications,
  makeSelectKeycloakToken,
  makeSelectListingsByField,
  makeSelectCurrentInstanceTab,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectExpertNotifications,
  makeSelectOpeningManagerNotificationsMixedClaim,
  makeSelectClaimNumber,
  makeSelectNotification,
  makeSelectOpenUnlockClaimDialog,
  makeSelectCurrentTabJudiciaryProcessManager,
  makeSelectCurrentTabManager,
  makeSelectGlobalCurrentTabManager,
  makeSelectNotifFeeNoteManager,
  makeSelectNotificationsInboxes,
  makeSelectCountNotificationManagers,
  makeSelectCountInboxesManagers,
  makeSelectCurrentTabIndexExpertise,
  makeSelectCurrentTabIndexTransaction,
  makeSelectTransactionId,
  makeSelectCurrentRegulationPath,
  makeSelectInboxesLawyerNotifications,
  makeSelectCountInboxesLawyerNotifications,
  makeSelectGlobalCurrentTabLawyer,
  makeSelectCurrentTabJudiciaryProcessLawyer,
  makeSelectCurrentTabLawyer,
};
